import { useContext } from 'react';
import { CreateTaxableEntityContext } from './CreateTaxableEntityProvider';

export default function useCreateTaxableEntityContext() {
    return useContext(CreateTaxableEntityContext);
};
